import type { Chat } from "@rivets/core";

/** The chat last read in each worktree, for the tab a worktree reopens on.
 * Per browser tab (session storage), as it always was. */
const LAST_CHAT_STORAGE_PREFIX = "rivets:last-viewed-chat:";

export function recalledChat(worktreeId: string): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage.getItem(`${LAST_CHAT_STORAGE_PREFIX}${worktreeId}`);
  } catch {
    return null;
  }
}

export function rememberChat(worktreeId: string, chatId: string): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(`${LAST_CHAT_STORAGE_PREFIX}${worktreeId}`, chatId);
  } catch {
    /* storage unavailable */
  }
}

export function mostRecentChatId(chats: Chat[]): string | null {
  if (chats.length === 0) return null;
  return [...chats].sort((a, b) => b.createdAt - a.createdAt)[0]?.id ?? null;
}

/** The chat a worktree would open on, ignoring any draft in front: the
 * remembered one when it still exists, else the newest. */
export function likelyChatId(chats: Chat[], worktreeId: string): string | null {
  const remembered = recalledChat(worktreeId);
  if (remembered && chats.some((chat) => chat.id === remembered)) return remembered;
  return mostRecentChatId(chats);
}
